import React from "react";
import PropTypes from "prop-types";
import "./Breadcrumb.scss";

const Breadcrumb = ({ items = [] }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="breadcrumb-wrapper">
      {items.map((item, index) => (
        <React.Fragment key={item.id || index}>
          <div className="breadcrumb-item">
            <div className="breadcrumb-label">{item.label}</div>
            <div className="breadcrumb-value">{item.value}</div>
          </div>
          {index < items.length - 1 && <div className="breadcrumb-separator">-</div>}
        </React.Fragment>
      ))}
    </div>
  );
};

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
};

export default Breadcrumb;
